// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * React Select
 * ============
 * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/
 * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
 * MIT License: https://github.com/JedWatson/react-select
*/
.Select {
  position: relative;
}
.Select input::-webkit-contacts-auto-fill-button,
.Select input::-webkit-credentials-auto-fill-button {
  display: none !important;
}
.Select input::-ms-clear {
  display: none !important;
}
.Select input::-ms-reveal {
  display: none !important;
}
.Select,
.Select div,
.Select input,
.Select span {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.Select.is-disabled .Select-arrow-zone {
  cursor: default;
  pointer-events: none;
  opacity: 0.35;
}
.Select.is-disabled > .Select-control {
  background-color: #f9f9f9;
}
.Select.is-disabled > .Select-control:hover {
  box-shadow: none;
}
.Select.is-open > .Select-control {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background: #fff;
  border-color: #b3b3b3 #ccc #d9d9d9;
}
.Select.is-open > .Select-control .Select-arrow {
  top: -2px;
  border-color: transparent transparent #999;
  border-width: 0 5px 5px;
}
.Select.is-searchable.is-open > .Select-control {
  cursor: text;
}
.Select.is-searchable.is-focused:not(.is-open) > .Select-control {
  cursor: text;
}
.Select.is-focused > .Select-control {
  background: #fff;
}
.Select.is-focused:not(.is-open) > .Select-control {
  border-color: #007eff;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1);
  background: #fff;
}
.Select.has-value.is-clearable.Select--single > .Select-control .Select-value {
  padding-right: 42px;
}
.Select.has-value.Select--single > .Select-control .Select-value .Select-value-label,
.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value .Select-value-label {
  color: #333;
}
.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label,
.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label {
  cursor: pointer;
  text-decoration: none;
}
.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label:hover,
.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:hover,
.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,
.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {
  color: #007eff;
  outline: none;
  text-decoration: underline;
}
.Select.has-value.Select--single > .Select-control .Select-value a.Select-value-label:focus,
.Select.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value a.Select-value-label:focus {
  background: #fff;
}
.Select.has-value.is-pseudo-focused .Select-input {
  opacity: 0;
}
.Select.is-open .Select-arrow,
.Select .Select-arrow-zone:hover > .Select-arrow {
  border-top-color: #666;
}
.Select.Select--rtl {
  direction: rtl;
  text-align: right;
}
.Select-control {
  background-color: #fff;
  border-color: #d9d9d9 #ccc #b3b3b3;
  border-radius: 4px;
  border: 1px solid #ccc;
  color: #333;
  cursor: default;
  display: table;
  border-spacing: 0;
  border-collapse: separate;
  height: 36px;
  outline: none;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.Select-control:hover {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}
.Select-control .Select-input:focus {
  outline: none;
  background: #fff;
}
.Select-placeholder,
.Select--single > .Select-control .Select-value {
  bottom: 0;
  color: #aaa;
  left: 0;
  line-height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  position: absolute;
  right: 0;
  top: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Select-input {
  height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.Select-input > input {
  width: 100%;
  background: none transparent;
  border: 0 none;
  box-shadow: none;
  cursor: default;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  outline: none;
  line-height: 17px;
  /* For IE 8 compatibility */
  padding: 8px 0 12px;
  /* For IE 8 compatibility */
  -webkit-appearance: none;
}
.is-focused .Select-input > input {
  cursor: text;
}
.has-value.is-pseudo-focused .Select-input {
  opacity: 0;
}
.Select-control:not(.is-searchable) > .Select-input {
  outline: none;
}
.Select-loading-zone {
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 16px;
}
.Select-loading {
  -webkit-animation: Select-animation-spin 400ms infinite linear;
  -o-animation: Select-animation-spin 400ms infinite linear;
  animation: Select-animation-spin 400ms infinite linear;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid #ccc;
  border-right-color: #333;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.Select-clear-zone {
  -webkit-animation: Select-animation-fadeIn 200ms;
  -o-animation: Select-animation-fadeIn 200ms;
  animation: Select-animation-fadeIn 200ms;
  color: #999;
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 17px;
}
.Select-clear-zone:hover {
  color: #D0021B;
}
.Select-clear {
  display: inline-block;
  font-size: 18px;
  line-height: 1;
}
.Select--multi .Select-clear-zone {
  width: 17px;
}
.Select-arrow-zone {
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 25px;
  padding-right: 5px;
}
.Select--rtl .Select-arrow-zone {
  padding-right: 0;
  padding-left: 5px;
}
.Select-arrow {
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
}
.Select-control > *:last-child {
  padding-right: 5px;
}
.Select--multi .Select-multi-value-wrapper {
  display: inline-block;
}
.Select .Select-aria-only {
  position: absolute;
  display: inline-block;
  height: 1px;
  width: 1px;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  overflow: hidden;
  float: left;
}
@-webkit-keyframes Select-animation-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes Select-animation-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.Select-menu-outer {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top-color: #e6e6e6;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  max-height: 200px;
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  z-index: 1;
  -webkit-overflow-scrolling: touch;
}
.Select-menu {
  max-height: 198px;
  overflow-y: auto;
}
.Select-option {
  box-sizing: border-box;
  background-color: #fff;
  color: #666666;
  cursor: pointer;
  display: block;
  padding: 8px 10px;
}
.Select-option:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.Select-option.is-selected {
  background-color: #f5faff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.04);
  color: #333;
}
.Select-option.is-focused {
  background-color: #ebf5ff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.08);
  color: #333;
}
.Select-option.is-disabled {
  color: #cccccc;
  cursor: default;
}
.Select-noresults {
  box-sizing: border-box;
  color: #999999;
  cursor: default;
  display: block;
  padding: 8px 10px;
}
.Select--multi .Select-input {
  vertical-align: middle;
  margin-left: 10px;
  padding: 0;
}
.Select--multi.Select--rtl .Select-input {
  margin-left: 0;
  margin-right: 10px;
}
.Select--multi.has-value .Select-input {
  margin-left: 5px;
}
.Select--multi .Select-value {
  background-color: #ebf5ff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.08);
  border-radius: 2px;
  border: 1px solid #c2e0ff;
  /* Fallback color for IE 8 */
  border: 1px solid rgba(0, 126, 255, 0.24);
  color: #007eff;
  display: inline-block;
  font-size: 0.9em;
  line-height: 1.4;
  margin-left: 5px;
  margin-top: 5px;
  vertical-align: top;
}
.Select--multi .Select-value-icon,
.Select--multi .Select-value-label {
  display: inline-block;
  vertical-align: middle;
}
.Select--multi .Select-value-label {
  border-bottom-right-radius: 2px;
  border-top-right-radius: 2px;
  cursor: default;
  padding: 2px 5px;
}
.Select--multi a.Select-value-label {
  color: #007eff;
  cursor: pointer;
  text-decoration: none;
}
.Select--multi a.Select-value-label:hover {
  text-decoration: underline;
}
.Select--multi .Select-value-icon {
  cursor: pointer;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  border-right: 1px solid #c2e0ff;
  /* Fallback color for IE 8 */
  border-right: 1px solid rgba(0, 126, 255, 0.24);
  padding: 1px 5px 3px;
}
.Select--multi .Select-value-icon:hover,
.Select--multi .Select-value-icon:focus {
  background-color: #d8eafd;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 113, 230, 0.08);
  color: #0071e6;
}
.Select--multi .Select-value-icon:active {
  background-color: #c2e0ff;
  /* Fallback color for IE 8 */
  background-color: rgba(0, 126, 255, 0.24);
}
.Select--multi.Select--rtl .Select-value {
  margin-left: 0;
  margin-right: 5px;
}
.Select--multi.Select--rtl .Select-value-icon {
  border-right: none;
  border-left: 1px solid #c2e0ff;
  /* Fallback color for IE 8 */
  border-left: 1px solid rgba(0, 126, 255, 0.24);
}
.Select--multi.is-disabled .Select-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
  color: #333;
}
.Select--multi.is-disabled .Select-value-icon {
  cursor: not-allowed;
  border-right: 1px solid #e3e3e3;
}
.Select--multi.is-disabled .Select-value-icon:hover,
.Select--multi.is-disabled .Select-value-icon:focus,
.Select--multi.is-disabled .Select-value-icon:active {
  background-color: #fcfcfc;
}
@keyframes Select-animation-spin {
  to {
    transform: rotate(1turn);
  }
}
@-webkit-keyframes Select-animation-spin {
  to {
    -webkit-transform: rotate(1turn);
  }
}
.Select .Select-control {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  border-radius: 0;
  height: 45px;
  line-height: 45px;
  position: relative;
  color: #444444;
  border-color: #444444;
}
.Select .Select-control .Select-multi-value-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: nowrap;
  white-space: nowrap;
  padding-right: 0;
  height: 100%;
  line-height: 43px;
  max-width: calc(100% - 45px);
}
.Select .Select-control .Select-multi-value-wrapper .Select-placeholder {
  flex: 1 1 auto;
  order: 2;
  height: 100%;
  line-height: inherit;
  opacity: 0.8;
  color: #bbbbbb;
  cursor: text;
  font-weight: 400;
  padding: 0 20px;
}
.Select .Select-control .Select-multi-value-wrapper .Select-input {
  flex: 1 1 auto;
  order: 1;
  height: 100%;
  line-height: inherit;
  margin: 0;
  padding: 0;
}
.Select .Select-control .Select-multi-value-wrapper .Select-input input {
  height: 100%;
  line-height: inherit;
  padding: 0;
}
.Select .Select-control .Select-multi-value-wrapper .ht-dropdown-tag {
  line-height: inherit;
  margin: 0;
  padding-right: 0;
  background: none;
  text-align: left;
  display: inline;
  text-overflow: ellipsis;
  overflow: hidden;
}
.Select .Select-control .Select-multi-value-wrapper .ht-dropdown-tag .delete-icon {
  display: none;
}
.Select .Select-control .Select-multi-value-wrapper .Select-value {
  display: flex;
  padding-left: 20px;
  padding-right: 0;
  flex: 1 1 auto;
  position: relative;
  line-height: 100%;
  align-items: center;
  align-content: center;
  cursor: pointer;
}
.Select .Select-control .Select-multi-value-wrapper .Select-value .Select-value-label {
  display: inline;
  text-overflow: ellipsis;
  overflow: hidden;
}
.Select .Select-control .Select-arrow-zone {
  flex: 0 0 45px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #444444;
  background-color: #f4f7f6;
  transition: 0.15s background-color;
  transform-origin: center center;
}
.Select .Select-control .Select-arrow-zone .Select-arrow {
  border: 0;
  color: #444444;
  width: auto;
  height: auto;
  transition: 0.15s background-color;
}
.Select .Select-control .Select-arrow-zone .Select-arrow::before {
  font-family: FontAwesome;
  content: '\\F078';
}
.Select .Select-menu-outer {
  z-index: 100;
  border-color: #444444;
  background-color: #f4f7f6;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.4);
  border-radius: 0;
}
.Select .Select-menu-outer .Select-menu .Select-option {
  color: #444444;
  background-color: #f4f7f6;
  transition: 0.15s background-color;
  display: flex;
  justify-content: space-between;
}
.Select .Select-menu-outer .Select-menu .Select-option.is-selected {
  background-color: #d8f2ec;
}
.Select .Select-menu-outer .Select-menu .Select-option.is-focused {
  background-color: #d8f2ec;
}
.Select .Select-menu-outer .Select-menu .Select-option.is-disabled {
  color: #bbbbbb;
}
.Select .Select-menu-outer .Select-menu .Select-option > hr {
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 2px;
  background-color: #bbbbbb;
  border: none;
}
.Select:focus {
  outline: none;
}
.Select:focus-within {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.Select.is-open .Select-arrow-zone {
  transform: rotate(180deg);
}
.Select.is-open .Select-control {
  border-color: #444444;
}
.Select.is-focused:not(.is-open) .Select-control {
  border-color: #444444;
  box-shadow: none;
  background-color: #ffffff;
}
.Select.is-searchable .Select-control .Select-multi-value-wrapper .Select-placeholder {
  flex: 1 1 auto;
  order: 2;
  height: 100%;
  line-height: inherit;
  color: #bbbbbb;
  cursor: text;
  font-weight: 400;
  padding: 0 20px;
}
.Select.is-searchable .Select-control .Select-multi-value-wrapper .Select-input {
  flex: 1 1 auto;
  order: 1;
  height: 100%;
  line-height: inherit;
  margin: 0;
  padding: 0;
  padding-left: 20px;
}
.Select.is-searchable .Select-control .Select-multi-value-wrapper .Select-input input {
  height: 100%;
  line-height: inherit;
  padding: 0;
}
.ht-dropdown-tags {
  margin: 1em 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
}
.ht-dropdown-tags .delete-icon {
  font-size: 22px;
  line-height: 45px;
  height: 45px;
  margin-left: 20px;
  padding-left: 10px;
  padding-right: 0;
}
.ht-dropdown .Select .Select-arrow-zone:hover {
  background-color: #d8f2ec;
}
.ht-dropdown .Select .Select-arrow-zone .Select-arrow:before {
  content: '\\F078';
}
.ht-dropdown .position-right {
  float: right;
}
.ht-dropdown-secondary {
  min-width: 250px;
}
.ht-dropdown-secondary .Select .Select-control {
  background-color: #d8f2ec;
  border: none;
  height: 36px;
  line-height: 36px;
}
.ht-dropdown-secondary .Select .Select-control .Select-multi-value-wrapper {
  line-height: inherit;
}
.ht-dropdown-secondary .Select .Select-control .Select-multi-value-wrapper .Select-placeholder {
  color: #bbbbbb;
}
.ht-dropdown-secondary .Select .Select-control .Select-arrow-zone {
  background-color: #d8f2ec;
}
.ht-dropdown-secondary .Select .Select-control .Select-arrow-zone .Select-arrow::before {
  content: '\\F107';
}
.ht-dropdown-secondary .Select .Select-menu-outer {
  border: 0;
}
.ht-dropdown-secondary .Select .Select-menu-outer .Select-menu .Select-option {
  background-color: #d8f2ec;
}
.ht-dropdown-secondary .Select .Select-menu-outer .Select-menu .Select-option.is-selected {
  background-color: #a7e6d7;
}
.ht-dropdown-secondary .Select .Select-menu-outer .Select-menu .Select-option.is-focused {
  background-color: #a7e6d7;
}
.ht-dropdown-secondary .Select.is-focused:not(.is-open) > .Select-control {
  background-color: #d8f2ec;
}
.ht-dropdown.has-error .Select .Select-control,
.ht-dropdown-secondary.has-error .Select .Select-control {
  border-color: #ff5035;
}
.ht-field-small {
  font-size: 12px;
}
.ht-field-small .Select-control {
  height: 28px;
  line-height: 28px;
  font-size: 9px;
}
.ht-field-small .Select-control .Select-multi-value-wrapper {
  line-height: inherit;
  max-width: calc(100% - 25px);
}
.ht-field-small .Select-control .Select-multi-value-wrapper .ht-dropdown-tag {
  font-size: 12px;
}
.ht-field-small .Select-control .tag-display {
  padding: 0 10px;
}
.ht-field-small .Select-control .Select-arrow-zone {
  flex: 0 0 25px;
}
`, "",{"version":3,"sources":["webpack://./../styleguide/src/components/Select/main.less","webpack://./../../node_modules/react-select/less/control.less","webpack://./../../node_modules/react-select/less/mixins.less","webpack://./../../node_modules/react-select/less/spinner.less","webpack://./../../node_modules/react-select/less/menu.less","webpack://./../../node_modules/react-select/less/multi.less"],"names":[],"mappings":"AAAA;;;;;;CAMC;ACeD;EACC,kBAAA;ADbD;ACYA;;EAME,wBAAA;ADdF;ACQA;EASE,wBAAA;ADdF;ACKA;EAYE,wBAAA;ADdF;ACkBC;;;;ECGA,8BAAA;EACA,2BAAA;EACA,sBAAA;AFfD;ACkBC;EAEE,eAAA;EACA,oBAAA;EACA,aAAA;ADjBH;ACaC;EAQE,yBAAA;ADlBH;ACmBG;EACC,gBAAA;ADjBJ;ACsBC;ECrCA,6BAAA;EACA,4BAAA;EDsCC,gBAAA;EACA,kCAAA;ADnBF;ACgBC;EAOE,SAAA;EACA,0CAAA;EACA,uBAAA;ADpBH;ACyBE;EACC,YAAA;ADvBH;AC0BE;EACC,YAAA;ADxBH;AC4BC;EACC,gBAAA;AD1BF;AC6BC;EA/EA,qBAAA;EACA,kFAAA;EACA,gBAAA;ADqDD;AC4BC;EACC,mBAAA;AD1BF;AC6BC;;EAGE,WAAA;AD5BH;ACyBC;;EAME,eAAA;EACA,qBAAA;AD3BH;AC6BG;;;;EAEC,cAAA;EACA,aAAA;EACA,0BAAA;ADzBJ;AC4BG;;EACC,gBAAA;ADzBJ;AC+BC;EACC,UAAA;AD7BF;ACgCC;;EAEC,sBAAA;AD9BF;ACgCC;EACC,cAAA;EACA,iBAAA;AD9BF;ACoCA;EACC,sBAAA;EACA,kCAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ADlCD;ACoCC;EACC,uCAAA;ADlCF;ACiBA;EAqBE,aAAA;EACA,gBAAA;ADnCF;ACwCA;;EAEC,SAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EAGA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADxCD;AC6CA;EAEC,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AD5CD;ACuCA;EAQE,WAAA;EACA,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,SAAA;EACA,aAAA;EAEA,iBAAA;ED9CA,2BAA2B;EC+C3B,mBAAA;ED7CA,2BAA2B;EC8C3B,wBAAA;AD5CF;AC8CE;EACC,YAAA;AD5CH;ACmDA;EACC,UAAA;ADjDD;ACqDA;EACC,aAAA;ADnDD;ACuDA;EACC,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ADrDD;ACuDA;ECrMC,8DAAA;EACA,yDAAA;EACA,sDAAA;EA7BA,WAAA;EACA,YAAA;ECFA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EF8NA,sBAAA;AD3CD;ACiDA;EC7MC,gDAAA;EACA,2CAAA;EACA,wCAAA;ED6MA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AD7CD;AC+CC;EACC,cAAA;AD7CF;ACgDA;EACC,qBAAA;EACA,eAAA;EACA,cAAA;AD9CD;ACgDA;EACC,WAAA;AD9CD;ACoDA;EACC,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;ADlDD;ACoDC;EACC,gBAAA;EACA,iBAAA;ADlDF;ACsDA;EACC,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;ADpDD;ACuDA;EACE,kBAAA;ADrDF;ACwDA;EACE,qBAAA;ADtDF;ACwDA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;ADtDF;AC8DA;EACC;IAAO,UAAA;ED3DN;EC4DD;IAAK,UAAA;EDzDJ;AACF;AC0DA;EACC;IAAO,UAAA;EDvDN;ECwDD;IAAK,UAAA;EDrDJ;AACF;AIrQA;EFgBC,+BAAA;EACA,8BAAA;EEXA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,iCAAA;AJoQD;AI9PA;EACC,iBAAA;EACA,gBAAA;AJgQD;AI1PA;EACC,sBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AJ4PD;AI1PC;EFxBA,+BAAA;EACA,8BAAA;AFqRD;AI1PC;EACC,yBAAA;EJ4PA,4BAA4B;EI3P5B,yCAAA;EACA,WAAA;AJ6PF;AI1PC;EACC,yBAAA;EJ4PA,4BAA4B;EI3P5B,yCAAA;EACA,WAAA;AJ6PF;AI1PC;EACC,cAAA;EACA,eAAA;AJ4PF;AIpPA;EACC,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AJsPD;AK7TA;EAIE,sBAAA;EAEA,iBAAA;EACA,UAAA;AL2TF;AKzTC;EACC,cAAA;EACA,kBAAA;AL2TF;AKvTC;EACC,gBAAA;ALyTF;AKzUA;EAqBE,yBAAA;ELuTA,4BAA4B;EKtT5B,yCAAA;EACA,kBAAA;EACA,yBAAA;ELwTA,4BAA4B;EKvT5B,yCAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;ALyTF;AKzVA;;EAsCE,qBAAA;EACA,sBAAA;ALuTF;AK9VA;EHYC,+BAAA;EACA,4BAAA;EGgCC,eAAA;EACA,gBAAA;ALsTF;AKpWA;EAiDE,cAAA;EACA,eAAA;EACA,qBAAA;ALsTF;AKpTE;EACC,0BAAA;ALsTH;AK5WA;EA4DE,eAAA;EHxCD,8BAAA;EACA,2BAAA;EGyCC,+BAAA;ELoTA,4BAA4B;EKnT5B,+CAAA;EAGA,oBAAA;ALmTF;AKjTE;;EAEC,yBAAA;ELmTD,4BAA4B;EKlT3B,yCAAA;EACA,cAAA;ALoTH;AKlTE;EACC,yBAAA;ELoTD,4BAA4B;EKnT3B,yCAAA;ALqTH;AKlTC;EAEG,cAAA;EACA,iBAAA;ALmTJ;AKtTC;EAME,kBAAA;EACA,8BAAA;ELmTD,4BAA4B;EKlT3B,8CAAA;ALoTH;AK/SA;EAEE,yBAAA;EACA,yBAAA;EACA,WAAA;ALgTF;AKpTA;EAQE,mBAAA;EACA,+BAAA;AL+SF;AK7SE;;;EAGC,yBAAA;AL+SH;AGhZA;EACC;IAAK,wBAAA;EHmZJ;AACF;AGlZA;EACC;IAAK,gCAAA;EHqZJ;AACF;AAvaA;EAEI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,qBAAA;AAwaJ;AAlbA;EAaM,aAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,4BAAA;AAwaN;AA5bA;EAuBQ,cAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAwaR;AAvcA;EAmCQ,cAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;AAuaR;AA/cA;EA2CU,YAAA;EACA,oBAAA;EACA,UAAA;AAuaV;AApdA;EAkDQ,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EAGA,eAAA;EACA,uBAAA;EACA,gBAAA;AAmaR;AA9dA;EA8DU,aAAA;AAmaV;AAjeA;EAmEQ,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAiaR;AA5eA;EA8EU,eAAA;EACA,uBAAA;EACA,gBAAA;AAiaV;AAjfA;EAsFM,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;EACA,yBAAA;EACA,kCAAA;EACA,+BAAA;AA8ZN;AA5fA;EAiGQ,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AA8ZR;AArZQ;EACE,wBAAA;EACA,gBAAA;AAuZV;AAvgBA;EAuHI,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,6CAAA;EACA,gBAAA;AAmZJ;AA9gBA;EA+HQ,cAAA;EACA,yBAAA;EACA,kCAAA;EACA,aAAA;EACA,8BAAA;AAkZR;AAhZQ;EACE,yBAAA;AAkZV;AA/YQ;EACE,yBAAA;AAiZV;AA9YQ;EACE,cAAA;AAgZV;AA9hBA;EAkJU,cAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;AA+YV;AAzYE;EACE,aAAA;AA2YJ;AAxYE;EACE,kFAAA;AA0YJ;AAvYE;EAEI,yBAAA;AAwYN;AA1YE;EAKI,qBAAA;AAwYN;AApYE;EAEI,qBAAA;EACA,gBAAA;EACA,yBAAA;AAqYN;AAjYE;EAIQ,cAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AAgYV;AA3YE;EAeQ,cAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AA+XV;AApZE;EAwBU,YAAA;EACA,oBAAA;EACA,UAAA;AA+XZ;AAvXA;EACE,aAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AAyXF;AA/XA;EASI,eAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AAyXJ;AAlXM;EACE,yBAAA;AAoXR;AAhXQ;EACE,gBAAA;AAkXV;AA3XA;EAgBI,YAAA;AA8WJ;AA1WA;EACE,gBAAA;AA4WF;AA7WA;EAKM,yBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AA2WN;AAnXA;EAWQ,oBAAA;AA2WR;AAtXA;EAcU,cAAA;AA2WV;AAzXA;EAmBQ,yBAAA;AAyWR;AAvWU;EACE,gBAAA;AAyWZ;AA/XA;EA6BM,SAAA;AAqWN;AAlYA;EAiCU,yBAAA;AAoWV;AAlWU;EACE,yBAAA;AAoWZ;AAjWU;EACE,yBAAA;AAmWZ;AA7VI;EAEI,yBAAA;AA8VR;AAtVE;;EAEI,qBAAA;AAwVN;AAnVA;EACE,eAAA;AAqVF;AAtVA;EAII,YAAA;EACA,iBAAA;EACA,cAAA;AAqVJ;AA3VA;EASM,oBAAA;EACA,4BAAA;AAqVN;AA/VA;EAaQ,eAAA;AAqVR;AAlWA;EAkBM,eAAA;AAmVN;AArWA;EAsBM,cAAA;AAkVN","sourcesContent":["@import '~react-select/less/default.less';\n@import '~styleguide/src/styles/variables.less';\n\n.Select {\n  .Select-control {\n    display: flex;\n    align-items: center;\n    flex-wrap: nowrap;\n    border-radius: 0;\n    height: 45px;\n    line-height: 45px;\n    position: relative;\n    color: @textBlack;\n    border-color: @textBlack;\n\n    .Select-multi-value-wrapper {\n      display: flex;\n      flex: 1 1 auto;\n      flex-wrap: nowrap;\n      white-space: nowrap;\n      padding-right: 0;\n      height: 100%;\n      line-height: 43px;\n      max-width: calc(~'100% - 45px');\n\n      .Select-placeholder {\n        flex: 1 1 auto;\n        order: 2;\n        height: 100%;\n        line-height: inherit;\n        opacity: 0.8;\n        color: @gray;\n        cursor: text;\n        font-weight: 400;\n        padding: 0 20px;\n      }\n\n      .Select-input {\n        flex: 1 1 auto;\n        order: 1;\n        height: 100%;\n        line-height: inherit;\n        margin: 0;\n        padding: 0;\n\n        input {\n          height: 100%;\n          line-height: inherit;\n          padding: 0;\n        }\n      }\n\n      .ht-dropdown-tag {\n        line-height: inherit;\n        margin: 0;\n        padding-right: 0;\n        background: none;\n        text-align: left;\n\n        // Just for the ellipsis, since flexbox can't do it.\n        display: inline;\n        text-overflow: ellipsis;\n        overflow: hidden;\n\n        .delete-icon {\n          display: none;\n        }\n      }\n\n      .Select-value {\n        display: flex;\n        padding-left: 20px;\n        padding-right: 0;\n        flex: 1 1 auto;\n        position: relative;\n        line-height: 100%;\n        align-items: center;\n        align-content: center;\n        cursor: pointer;\n\n        .Select-value-label {\n          display: inline;\n          text-overflow: ellipsis;\n          overflow: hidden;\n        }\n      }\n    }\n\n    .Select-arrow-zone {\n      flex: 0 0 45px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n      color: @textBlack;\n      background-color: @bkgdBlue;\n      transition: 0.15s background-color;\n      transform-origin: center center;\n\n      .Select-arrow {\n        border: 0;\n        color: @textBlack;\n        width: auto;\n        height: auto;\n        transition: 0.15s background-color;\n\n        // NOTE: we should avoid using CSS content, but...\n        // I don't know how to control the arrow rendering\n        // with the properties in react-select. From the react-select\n        // v2 docs I see there's an arrowRenderer function in the\n        // migration guide but I don't see any mention of that in the\n        // v1 docs. So it seems reasonable to me to use this in\n        // overwriting a third-party component's styles.\n        &::before {\n          font-family: FontAwesome;\n          content: '\\F078'; // fa-chevron-down\n        }\n      }\n    }\n  }\n\n  .Select-menu-outer {\n    z-index: 100;\n    border-color: @textBlack;\n    background-color: @bkgdBlue;\n    box-shadow: @dropdown-shadow;\n    border-radius: 0;\n\n    .Select-menu {\n      .Select-option {\n        color: @textBlack;\n        background-color: @bkgdBlue;\n        transition: 0.15s background-color;\n        display: flex;\n        justify-content: space-between;\n\n        &.is-selected {\n          background-color: @lightMint;\n        }\n\n        &.is-focused {\n          background-color: @lightMint;\n        }\n\n        &.is-disabled {\n          color: @gray;\n        }\n\n        > hr {\n          display: block;\n          margin: 0;\n          padding: 0;\n          width: 100%;\n          height: 2px;\n          background-color: @gray;\n          border: none;\n        }\n      }\n    }\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &:focus-within {\n    box-shadow: @input-focus-shadow;\n  }\n\n  &.is-open {\n    .Select-arrow-zone {\n      transform: rotate(180deg);\n    }\n    .Select-control {\n      border-color: @textBlack;\n    }\n  }\n\n  &.is-focused:not(.is-open) {\n    .Select-control {\n      border-color: @textBlack;\n      box-shadow: none;\n      background-color: @white;\n    }\n  }\n\n  &.is-searchable {\n    .Select-control {\n      .Select-multi-value-wrapper {\n        .Select-placeholder {\n          flex: 1 1 auto;\n          order: 2;\n          height: 100%;\n          line-height: inherit;\n          color: @gray;\n          cursor: text;\n          font-weight: 400;\n          padding: 0 20px;\n        }\n\n        .Select-input {\n          flex: 1 1 auto;\n          order: 1;\n          height: 100%;\n          line-height: inherit;\n          margin: 0;\n          padding: 0;\n          padding-left: 20px;\n\n          input {\n            height: 100%;\n            line-height: inherit;\n            padding: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n.ht-dropdown-tags {\n  margin: 1em 0;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: center;\n  flex-wrap: wrap;\n\n  .delete-icon {\n    font-size: 22px;\n    line-height: 45px;\n    height: 45px;\n    margin-left: 20px;\n    padding-left: 10px;\n    padding-right: 0;\n  }\n}\n\n.ht-dropdown {\n  .Select {\n    .Select-arrow-zone {\n      &:hover {\n        background-color: @lightMint;\n      }\n\n      .Select-arrow {\n        &:before {\n          content: '\\F078'; // fa-chevron-down\n        }\n      }\n    }\n  }\n\n  .position-right {\n    float: right;\n  }\n}\n\n.ht-dropdown-secondary {\n  min-width: 250px;\n\n  .Select {\n    .Select-control {\n      background-color: @lightMint;\n      border: none;\n      height: 36px;\n      line-height: 36px;\n\n      .Select-multi-value-wrapper {\n        line-height: inherit;\n\n        .Select-placeholder {\n          color: @gray;\n        }\n      }\n\n      .Select-arrow-zone {\n        background-color: @lightMint;\n        .Select-arrow {\n          &::before {\n            content: '\\F107'; // angle-down\n          }\n        }\n      }\n    }\n\n    .Select-menu-outer {\n      border: 0;\n\n      .Select-menu {\n        .Select-option {\n          background-color: @lightMint;\n\n          &.is-selected {\n            background-color: @mint;\n          }\n\n          &.is-focused {\n            background-color: @mint;\n          }\n        }\n      }\n    }\n\n    &.is-focused:not(.is-open) {\n      > .Select-control {\n        background-color: @lightMint;\n      }\n    }\n  }\n}\n\n.ht-dropdown,\n.ht-dropdown-secondary {\n  &.has-error {\n    .Select .Select-control {\n      border-color: @red;\n    }\n  }\n}\n\n.ht-field-small {\n  font-size: 12px;\n\n  .Select-control {\n    height: 28px;\n    line-height: 28px;\n    font-size: 9px;\n\n    .Select-multi-value-wrapper {\n      line-height: inherit;\n      max-width: calc(100% - 25px);\n\n      .ht-dropdown-tag {\n        font-size: 12px;\n      }\n    }\n\n    .tag-display {\n      padding: 0 10px;\n    }\n\n    .Select-arrow-zone {\n      flex: 0 0 25px;\n    }\n  }\n}\n","//\n// Control\n// ------------------------------\n\n// Mixins\n\n// focused styles\n.Select-focus-state(@color) {\n\tborder-color: @color;\n\tbox-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px fade(@color, 10%);\n\tbackground: @select-input-bg-focus;\n}\n// \"classic\" focused styles: maintain for legacy\n.Select-focus-state-classic() {\n\tborder-color: @select-input-border-focus lighten(@select-input-border-focus, 5%) lighten(@select-input-border-focus, 5%);\n\tbox-shadow: @select-input-box-shadow-focus;\n\tbackground: @select-input-bg-focus;\n}\n\n// base\n\n.Select {\n\tposition: relative;\n\n\t// disable some browser-specific behaviours that break the input\n\tinput::-webkit-contacts-auto-fill-button,\n\tinput::-webkit-credentials-auto-fill-button {\n\t\tdisplay: none !important;\n\t}\n\tinput::-ms-clear {\n\t\tdisplay: none !important;\n\t}\n\tinput::-ms-reveal {\n\t\tdisplay: none !important;\n\t}\n\n\t// preferred box model\n\t&,\n\t& div,\n\t& input,\n\t& span {\n\t\t.box-sizing(border-box);\n\t}\n\n\t// handle disabled state\n\t&.is-disabled {\n\t\t.Select-arrow-zone {\n\t\t\tcursor: default;\n\t\t\tpointer-events: none;\n\t\t\topacity: 0.35;\n\t\t}\n\n\t\t> .Select-control {\n\t\t\tbackground-color: @select-input-bg-disabled;\n\t\t\t&:hover {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.is-open > .Select-control {\n\t\t.border-bottom-radius( 0 );\n\t\tbackground: @select-input-bg;\n\t\tborder-color: darken(@select-input-border-color, 10%) @select-input-border-color lighten(@select-input-border-color, 5%);\n\n\t\t// flip the arrow so its pointing up when the menu is open\n\t\t.Select-arrow {\n\t\t\ttop: -2px;\n\t\t\tborder-color: transparent transparent @select-arrow-color;\n\t\t\tborder-width: 0 @select-arrow-width @select-arrow-width;\n\t\t}\n\t}\n\n\t&.is-searchable {\n\t\t&.is-open > .Select-control {\n\t\t\tcursor: text;\n\t\t}\n\n\t\t&.is-focused:not(.is-open) > .Select-control {\n\t\t\tcursor: text;\n\t\t}\n\t}\n\n\t&.is-focused > .Select-control {\n\t\tbackground: @select-input-bg-focus;\n\t}\n\n\t&.is-focused:not(.is-open) > .Select-control {\n\t\t.Select-focus-state(@select-input-border-focus);\n\t}\n\n\t&.has-value.is-clearable.Select--single > .Select-control .Select-value {\n\t\tpadding-right: (@select-clear-width + @select-arrow-width * 5);\n\t}\n\n\t&.has-value.Select--single > .Select-control .Select-value,\n\t&.has-value.is-pseudo-focused.Select--single > .Select-control .Select-value {\n\t\t.Select-value-label {\n\t\t\tcolor: @select-text-color;\n\t\t}\n\t\ta.Select-value-label {\n\t\t\tcursor: pointer;\n\t\t\ttext-decoration: none;\n\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tcolor: @select-link-hover-color;\n\t\t\t\toutline: none;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\n\t\t\t&:focus {\n\t\t\t\tbackground: @select-input-bg-focus;\n\t\t\t}\n\t\t}\n\t}\n\n\t// fake-hide the input when the control is pseudo-focused\n\t&.has-value.is-pseudo-focused .Select-input {\n\t\topacity: 0;\n\t}\n\n\t&.is-open .Select-arrow,\n\t.Select-arrow-zone:hover > .Select-arrow {\n\t\tborder-top-color: @select-arrow-color-hover;\n\t}\n\t&.Select--rtl {\n\t\tdirection: rtl;\n\t\ttext-align: right;\n\t}\n}\n\n// base\n\n.Select-control {\n\tbackground-color: @select-input-bg;\n\tborder-color: lighten(@select-input-border-color, 5%) @select-input-border-color darken(@select-input-border-color, 10%);\n\tborder-radius: @select-input-border-radius;\n\tborder: @select-input-border-width solid @select-input-border-color;\n\tcolor: @select-text-color;\n\tcursor: default;\n\tdisplay: table;\n\tborder-spacing: 0;\n\tborder-collapse: separate;\n\theight: @select-input-height;\n\toutline: none;\n\toverflow: hidden;\n\tposition: relative;\n\twidth: 100%;\n\n\t&:hover {\n\t\tbox-shadow: @select-input-hover-box-shadow;\n\t}\n\n\t.Select-input:focus {\n\t\toutline: none;\n\t\tbackground: @select-input-bg-focus;\n\t}\n}\n\n// placeholder\n.Select-placeholder,\n.Select--single > .Select-control .Select-value {\n\tbottom: 0;\n\tcolor: @select-input-placeholder;\n\tleft: 0;\n\tline-height: @select-input-internal-height;\n\tpadding-left: @select-padding-horizontal;\n\tpadding-right: @select-padding-horizontal;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\n\t// crop text\n\tmax-width: 100%;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n// the <input> element users type in\n\n.Select-input {\n\t// inherits `display: inline-block` from \"react-input-autosize\"\n\theight: @select-input-internal-height;\n\tpadding-left: @select-padding-horizontal;\n\tpadding-right: @select-padding-horizontal;\n\tvertical-align: middle;\n\n\t> input {\n\t\twidth: 100%;\n\t\tbackground: none transparent;\n\t\tborder: 0 none;\n\t\tbox-shadow: none;\n\t\tcursor: default;\n\t\tdisplay: inline-block;\n\t\tfont-family: inherit;\n\t\tfont-size: inherit;\n\t\t// height: @select-input-internal-height;\n\t\tmargin: 0;\n\t\toutline: none;\n\t\t// padding: 0;\n\t\tline-height: 17px;  /* For IE 8 compatibility */\n\t\tpadding: ((@select-input-internal-height - 14) / 2 - 2) 0 ((@select-input-internal-height - 14) / 2 + 2);  /* For IE 8 compatibility */\n\t\t-webkit-appearance: none;\n\n\t\t.is-focused & {\n\t\t\tcursor: text;\n\t\t}\n\t}\n\n}\n\n// fake-hide the input when the control is pseudo-focused\n.has-value.is-pseudo-focused .Select-input {\n\topacity: 0;\n}\n\n// fake input\n.Select-control:not(.is-searchable) > .Select-input {\n\toutline: none;\n}\n\n// loading indicator\n.Select-loading-zone {\n\tcursor: pointer;\n\tdisplay: table-cell;\n\tposition: relative;\n\ttext-align: center;\n\tvertical-align: middle;\n\twidth: @select-loading-size;\n}\n.Select-loading {\n\t.Select-spinner(@select-loading-size, @select-loading-color-bg, @select-loading-color);\n\tvertical-align: middle;\n}\n\n\n// the little cross that clears the field\n\n.Select-clear-zone {\n\t.animation( Select-animation-fadeIn 200ms );\n\tcolor: @select-clear-color;\n\tcursor: pointer;\n\tdisplay: table-cell;\n\tposition: relative;\n\ttext-align: center;\n\tvertical-align: middle;\n\twidth: @select-clear-width;\n\n\t&:hover {\n\t\tcolor: @select-clear-hover-color;\n\t}\n}\n.Select-clear {\n\tdisplay: inline-block;\n\tfont-size: @select-clear-size;\n\tline-height: 1;\n}\n.Select--multi .Select-clear-zone {\n\twidth: @select-clear-width;\n}\n\n\n// arrow indicator\n\n.Select-arrow-zone {\n\tcursor: pointer;\n\tdisplay: table-cell;\n\tposition: relative;\n\ttext-align: center;\n\tvertical-align: middle;\n\twidth: (@select-arrow-width * 5);\n\tpadding-right: @select-arrow-width;\n\n\t.Select--rtl & {\n\t\tpadding-right: 0;\n\t\tpadding-left: @select-arrow-width;\n\t}\n}\n\n.Select-arrow {\n\tborder-color: @select-arrow-color transparent transparent;\n\tborder-style: solid;\n\tborder-width: @select-arrow-width @select-arrow-width (@select-arrow-width / 2);\n\tdisplay: inline-block;\n\theight: 0;\n\twidth: 0;\n\tposition: relative;\n}\n\n.Select-control > *:last-child {\n  padding-right: @select-right-padding;\n}\n\n.Select--multi .Select-multi-value-wrapper {\n  display: inline-block;\n}\n.Select .Select-aria-only {\n  position: absolute;\n  display: inline-block;\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  clip: rect(0,0,0,0);\n  overflow: hidden;\n  float: left;\n}\n\n// Animation\n// ------------------------------\n\n// fade in\n\n@-webkit-keyframes Select-animation-fadeIn {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n@keyframes Select-animation-fadeIn {\n\tfrom { opacity: 0; }\n\tto { opacity: 1; }\n}\n","//\n// Mixins\n// ------------------------------\n\n\n// Utilities\n\n.size(@width; @height) {\n\twidth: @width;\n\theight: @height;\n}\n.square(@size) {\n\t.size(@size; @size);\n}\n.border-top-radius(@radius) {\n\tborder-top-right-radius: @radius;\n\tborder-top-left-radius: @radius;\n}\n.border-right-radius(@radius) {\n\tborder-bottom-right-radius: @radius;\n\tborder-top-right-radius: @radius;\n}\n.border-bottom-radius(@radius) {\n\tborder-bottom-right-radius: @radius;\n\tborder-bottom-left-radius: @radius;\n}\n.border-left-radius(@radius) {\n\tborder-bottom-left-radius: @radius;\n\tborder-top-left-radius: @radius;\n}\n\n\n// Vendor Prefixes\n\n.animation(@animation) {\n\t-webkit-animation: @animation;\n\t-o-animation: @animation;\n\tanimation: @animation;\n}\n.box-sizing(@boxmodel) {\n\t-webkit-box-sizing: @boxmodel;\n\t-moz-box-sizing: @boxmodel;\n\tbox-sizing: @boxmodel;\n}\n.rotate(@degrees) {\n\t-webkit-transform: rotate(@degrees);\n\t-ms-transform: rotate(@degrees); // IE9 only\n\t-o-transform: rotate(@degrees);\n\ttransform: rotate(@degrees);\n}\n.transform(@transform) {\n\t-webkit-transform: @transform;\n\t-moz-transform: @transform;\n\t-ms-transform: @transform;\n\ttransform: @transform;\n}\n","// \n// Spinner\n// ------------------------------\n\n.Select-spinner(@size, @orbit, @satellite) {\n\t.animation( Select-animation-spin 400ms infinite linear );\n\t.square(@size);\n\tbox-sizing: border-box;\n\tborder-radius: 50%;\n\tborder: floor((@size / 8)) solid @orbit;\n\tborder-right-color: @satellite;\n\tdisplay: inline-block;\n\tposition: relative;\n\t\n}\n\n@keyframes Select-animation-spin {\n\tto { transform: rotate(1turn); }\n}\n@-webkit-keyframes Select-animation-spin {\n\tto { -webkit-transform: rotate(1turn); }\n}\n","//\n// Select Menu\n// ------------------------------\n\n\n// wrapper around the menu\n\n.Select-menu-outer {\n\t// Unfortunately, having both border-radius and allows scrolling using overflow defined on the same\n\t// element forces the browser to repaint on scroll.  However, if these definitions are split into an\n\t// outer and an inner element, the browser is able to optimize the scrolling behavior and does not\n\t// have to repaint on scroll.\n\t.border-bottom-radius( @select-input-border-radius );\n\tbackground-color: @select-input-bg;\n\tborder: 1px solid @select-input-border-color;\n\tborder-top-color: mix(@select-input-bg, @select-input-border-color, 50%);\n\tbox-shadow: @select-menu-box-shadow;\n\tbox-sizing: border-box;\n\tmargin-top: -1px;\n\tmax-height: @select-menu-max-height;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 100%;\n\twidth: 100%;\n\tz-index: @select-menu-zindex;\n\t-webkit-overflow-scrolling: touch;\n}\n\n\n// wrapper\n\n.Select-menu {\n\tmax-height: (@select-menu-max-height - 2px);\n\toverflow-y: auto;\n}\n\n\n// options\n\n.Select-option {\n\tbox-sizing: border-box;\n\tbackground-color: @select-option-bg;\n\tcolor: @select-option-color;\n\tcursor: pointer;\n\tdisplay: block;\n\tpadding: @select-padding-vertical @select-padding-horizontal;\n\n\t&:last-child {\n\t\t.border-bottom-radius( @select-input-border-radius );\n\t}\n\n\t&.is-selected {\n\t\tbackground-color: @select-option-selected-bg-fb;  /* Fallback color for IE 8 */\n\t\tbackground-color: @select-option-selected-bg;\n\t\tcolor: @select-option-selected-color;\n\t}\n\n\t&.is-focused {\n\t\tbackground-color: @select-option-focused-bg-fb;  /* Fallback color for IE 8 */\n\t\tbackground-color: @select-option-focused-bg;\n\t\tcolor: @select-option-focused-color;\n\t}\n\n\t&.is-disabled {\n\t\tcolor: @select-option-disabled-color;\n\t\tcursor: default;\n\t}\n\n}\n\n\n// no results\n\n.Select-noresults {\n\tbox-sizing: border-box;\n\tcolor: @select-noresults-color;\n\tcursor: default;\n\tdisplay: block;\n\tpadding: @select-padding-vertical @select-padding-horizontal;\n}\n","//\n// Multi-Select\n// ------------------------------\n\n\n// Base\n\n.Select--multi {\n\n\t// add margin to the input element\n\t.Select-input {\n\t\tvertical-align: middle;\n\t\t// border: 1px solid transparent;\n\t\tmargin-left: @select-padding-horizontal;\n\t\tpadding: 0;\n\t}\n\t&.Select--rtl .Select-input {\n\t\tmargin-left: 0;\n\t\tmargin-right: @select-padding-horizontal;\n\t}\n\n\t// reduce margin once there is value\n\t&.has-value .Select-input {\n\t\tmargin-left: @select-item-gutter;\n\t}\n\n\t// Items\n\t.Select-value {\n\t\tbackground-color: @select-item-bg-fb;  /* Fallback color for IE 8 */\n\t\tbackground-color: @select-item-bg;\n\t\tborder-radius: @select-item-border-radius;\n\t\tborder: 1px solid @select-item-border-color-fb;  /* Fallback color for IE 8 */\n\t\tborder: 1px solid @select-item-border-color;\n\t\tcolor: @select-item-color;\n\t\tdisplay: inline-block;\n\t\tfont-size: @select-item-font-size;\n\t\tline-height: 1.4;\n\t\tmargin-left: @select-item-gutter;\n\t\tmargin-top: @select-item-gutter;\n\t\tvertical-align: top;\n\t}\n\n\t// common\n\t.Select-value-icon,\n\t.Select-value-label {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n\n\t// label\n\t.Select-value-label {\n\t\t.border-right-radius( @select-item-border-radius );\n\t\tcursor: default;\n\t\tpadding: @select-item-padding-vertical @select-item-padding-horizontal;\n\t}\n\ta.Select-value-label {\n\t\tcolor: @select-item-color;\n\t\tcursor: pointer;\n\t\ttext-decoration: none;\n\n\t\t&:hover {\n\t\t\ttext-decoration: underline;\n\t\t}\n\t}\n\n\t// icon\n\t.Select-value-icon {\n\t\tcursor: pointer;\n\t\t.border-left-radius( @select-item-border-radius );\n\t\tborder-right: 1px solid @select-item-border-color-fb;  /* Fallback color for IE 8 */\n\t\tborder-right: 1px solid @select-item-border-color;\n\n\t\t// move the baseline up by 1px\n\t\tpadding: (@select-item-padding-vertical - 1) @select-item-padding-horizontal (@select-item-padding-vertical + 1);\n\n\t\t&:hover,\n\t\t&:focus {\n\t\t\tbackground-color: @select-item-hover-bg-fb;  /* Fallback color for IE 8 */\n\t\t\tbackground-color: @select-item-hover-bg;\n\t\t\tcolor: @select-item-hover-color;\n\t\t}\n\t\t&:active {\n\t\t\tbackground-color: @select-item-border-color-fb;  /* Fallback color for IE 8 */\n\t\t\tbackground-color: @select-item-border-color;\n\t\t}\n\t}\n\t&.Select--rtl {\n\t\t.Select-value {\n\t\t  margin-left: 0;\n\t\t  margin-right: @select-item-gutter;\n\t\t}\n\t\t.Select-value-icon {\n\t\t\tborder-right: none;\n\t\t\tborder-left: 1px solid @select-item-border-color-fb; /* Fallback color for IE 8 */\n\t\t\tborder-left: 1px solid @select-item-border-color;\n\t\t}\n\t}\n}\n\n.Select--multi.is-disabled {\n\t.Select-value {\n\t\tbackground-color: @select-item-disabled-bg;\n\t\tborder: 1px solid @select-item-disabled-border-color;\n\t\tcolor: @select-item-disabled-color;\n\t}\n\t// icon\n\t.Select-value-icon {\n\t\tcursor: not-allowed;\n\t\tborder-right: 1px solid @select-item-disabled-border-color;\n\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground-color: @select-item-disabled-bg;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
